/* eslint-disable @typescript-eslint/no-explicit-any */
import { setLang, type Lang } from '@lib/i18n';
import { apiRequest } from '@client/lib/apiRequest';
import { getWebApp } from '@client/lib/Telegram';
import type { IGetInitialInfoResult } from '@typings/api/IGetInitialInfoResult';

function getLanguage(): Promise<Lang | undefined> {
    return new Promise(resolve => {
        getWebApp().CloudStorage.getItem('lang', (error: any, value: string) => {
            if (error) {
                console.error('Telegram.WebApp.CloudStorage failed', error);
                resolve(undefined);

                return;
            }

            resolve(value as Lang);
        });
    });
}

export async function initApp(): Promise<void> {
    const isTelegram = Boolean(getWebApp().initData);

    getWebApp().enableClosingConfirmation();
    getWebApp().expand();

    if (!isTelegram) {
        setLang(window.RentApp.lang);

        return;
    }

    const [language, userInfo] = await Promise.all([
        getLanguage(),
        apiRequest<IGetInitialInfoResult>('getInitialInfo'),
    ]);

    if (language) {
        setLang(language);
    }

    if (userInfo.ok) {
        window.RentApp.userInfo = userInfo.result.user;
    }
}
